import { render, staticRenderFns } from "./ProductEditImages.vue?vue&type=template&id=02626b1a&scoped=true"
import script from "./ProductEditImages.vue?vue&type=script&lang=ts"
export * from "./ProductEditImages.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditImages.vue?vue&type=style&index=0&id=02626b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02626b1a",
  null
  
)

export default component.exports